/**
 * Development-only logging utility
 * Logs only in development mode, silent in production
 */

export interface LogLevel {
  DEBUG: 'debug';
  INFO: 'info';
  WARN: 'warn';
  ERROR: 'error';
}

export const LOG_LEVELS: LogLevel = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
};

class Logger {
  private isDevelopment: boolean;

  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
  }

  debug(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.log(`[INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  error(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.error(`[ERROR] ${message}`, ...args);
    }
  }

  // API specific logging
  api(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.log(`[API] ${message}`, ...args);
    }
  }

  // Redux specific logging
  redux(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.log(`[REDUX] ${message}`, ...args);
    }
  }

  // Service specific logging
  service(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      console.log(`[SERVICE] ${message}`, ...args);
    }
  }
}

export const logger = new Logger();
export default logger;